export const getRequiredMessage = (title: string) => `${title} is required.`; // error msg for empty input

export const CONFIRM_CLOSE_UNSAVED_TITLE = 'Are you sure you want to close?';
export const CONFIRM_CLOSE_UNSAVED_DESC =
  'You have unsaved changes, are you sure you want to close?';

export const CONFIRM_TAB_SWITCH_TITLE = 'Are you sure you want to leave?';
export const CONFIRM_SWITCH_UNSAVED_DESC =
  'You have unsaved changes, are you sure you want to leave?';

export const CONFIRM_LEAVE_PENDING_UPLOADS_DESC =
  'Some documents are still being uploaded, are you sure you want to leave?';
